var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreadSlice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 32C132.369 32 0 96.291 0 192C0 227.289 26.916 256 60 256H64V432C64 458.51 85.49 480 112 480H400C426.51 480 448 458.51 448 432V256H452C485.084 256 512 227.289 512 192C512 96.291 379.631 32 256 32ZM452 208H400V432H112V208H60C54.25 208 48 201.625 48 192C48 132.375 153.75 80 256 80S464 132.375 464 192C464 201.625 457.75 208 452 208Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadSlice);
export default __webpack_public_path__ + "static/media/bread-slice.1f974f74976ab4b43b5e2bb435b1c107.svg";
export { ForwardRef as ReactComponent };